import type { FC } from 'react';
import { ThemeProvider } from 'styled-components';

import { theme } from './config';

export const GlobalThemeProvider: FC = ({ children }) => (
    <ThemeProvider theme={theme}>{children}</ThemeProvider>
);
